import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.to-string";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
import { creatUUid } from "@/api/utils/apiHelper";
/**
 * base64转二进制
 * @param dataurl
 */

export var dataURLtoBlob = function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(",");
  var mimeString = arr[0].match(/:(.*?);/)[1];
  console.log("dataURLtoBlob", mimeString);
  var byteString = atob(arr[1]);
  var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组

  var intArray = new Uint8Array(arrayBuffer); //创建视图

  for (var i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([intArray], {
    type: mimeString
  });
};
export var writeFile = function writeFile(fileEntry, dataObj) {
  var isAppend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  //创建一个写入对象
  return new _Promise(function (resolve, reject) {
    try {
      fileEntry.createWriter(function (fileWriter) {
        //文件写入成功
        fileWriter.onwriteend = function () {
          console.log("Successful file write...");
          resolve();
        }; //文件写入失败


        fileWriter.onerror = function (e) {
          console.log("Failed file write: " + e.toString());
          reject(e);
        }; //写入文件


        fileWriter.write(dataObj);
      });
    } catch (error) {
      reject(error);
    }
  });
};
export var saveFile = function saveFile(dirEntry, base64) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var blob, randomFileName;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              blob = dataURLtoBlob(base64); //转为二进制

              console.log("safaFile:", blob);
              randomFileName = creatUUid() + ".jpeg";
              dirEntry.getFile(randomFileName, {
                create: true,
                exclusive: false
              },
              /*#__PURE__*/
              function () {
                var _ref2 = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee(fileEntry) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return writeFile(fileEntry, blob);

                        case 2:
                          resolve(randomFileName);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }(), function (error) {
                console.log("getFile error:", error);
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};
export var recoverEditFilePath = function recoverEditFilePath(base64) {
  return new _Promise(function (resolve, reject) {
    try {
      window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0,
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee3(fs) {
          var saveFileResult;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  console.log("打开的文件系统: ", fs);
                  _context3.next = 3;
                  return saveFile(fs.root, base64);

                case 3:
                  saveFileResult = _context3.sent;
                  //返回文件名：
                  saveFileResult = (fs.root.nativeURL + saveFileResult).replace("file://", "");
                  resolve(saveFileResult);

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }(), function (error) {
        reject(error);
        console.log("打开的文件系统 error: " + error);
      });
    } catch (error) {
      reject(error);
    }
  });
};